export default {
  // 中英文名
  regName: /^([\u4E00-\u9FA5\uF900-\uFA2D]){2,20}|([a-zA-Z\s]){2,50}$/,
  // 中文名
  Name: /^([\u4E00-\u9FA5\uF900-\uFA2D.]){2,20}$/,
  // 英文姓名
  enName: /^([a-zA-Z.\s]){2,50}$/,
  // 公司
  // ComName: /^[\u4E00-\u9FA5A-Za-z0-9-_.,()（）'\s]+$/,
  ComName: /^.{2,200}$/,
  // 公司中文名称
  ComNameCn: /^[\u4E00-\u9FA5-_.,()（）'\s]+$/,
  // 公司英文名称
  // ComNameEn: /^[A-Za-z0-9-_.,()（）'"\s]+$/,
  ComNameEn: /^.{2,200}$/,
  // 职务
  Rank: /^[a-zA-Z\u4e00-\u9fa5,\s]+$/,
  // 部门
  Depart: /^[\u4E00-\u9FA5A-Za-z-_()（）/\s]+$/,
  // 手机
  Mobile: /^1[3-9]\d{8}$/,
  // 手机
  regCheckCnMobile: /^1(3[0-9]|5[0-9]|8[0-9]|4[0-9]|7[0-9]|6[0-9]|9[0-9])\d{8}$/,
  // 邮箱
  Email: /^[A-Za-z0-9_\-.\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
  // 描述中文
  descCn: /^[\u4e00-\u9fa5,\s。，]+$/,
  // 描述英文
  descEn: /^([a-zA-Z,.\s])+$/,
  // 地址中文
  addressCn: /^.{6,200}$/,
  // 地址英文
  addressEn: /^.{6,200}$/,
  // 国内邮编
  ZipCode: /^[0-9a-zA-Z]{6}$/,
  // 港澳台邮编
  hmtZipCode: /^\d{5,6}$/,
  // 国外邮编
  enZipCode: /^[0-9a-zA-Z]{3,}$/,
  // 网址
  webUrl: /^((ht|f)tps?):\/\/[\w-]+(.[\w-]+)+([\w-.,@?^=%&:/~+#]+[\w\-@?^=%&/~+#])?$/,
  // 国内电话、传真
  // Tel: /^([0-9]{1,4}[-]){1}([0-9]{1,4}[-]){1}([0-9]{7,8})([-][0-9]{0,5}){0,1}$/,
  Tel: /^([0-9]{1,4}[-]){1}([0-9]{1,4}[-]){0,1}([0-9]{7,8})([-][0-9]{0,5}){0,1}$/,
  // Telcn: /^([0-9]{1,4}[-]){1}([0-9]{1,4}[-]){0,1}([0-9]{7,11})([-][0-9]{0,5}){0,1}$/,
  Telcn: /^([0-9,-])+$/,
  // 国外电话、传真
  enTel: /^([0-9]{1,4}[-]){1}([1-9][0-9]{5,11})([-][0-9]{0,6}){0,1}$/,
  // 身份证
  // 18位
  idCard: /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/,
  // 15位
  idCard2: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
  // 护照
  passport: /^[a-zA-Z]{5,17}$/,
  passport2: /^[a-zA-Z0-9]{5,17}$/,
  // 港澳通行证验证
  hmPass: /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/,
  // 台湾通行证验证
  tPass: /^[0-9]{8}$/,
  tPass2: /^[0-9]{10}$/,
  // 验证 身份证
  regCId (regID) {
    var val = regID
    var isT = validateIdCard(val)
    return isT
    function validateIdCard (idCard) {
      var vcity = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外' }
      if (idCard === '') {
        return false
      }
      if (isCardNo(idCard) === false) {
        return false
      }
      if (checkProvince(idCard, vcity) === false) {
        return false
      }
      if (checkBirthday(idCard) === false) {
        return false
      }
      if (checkParity(idCard) === false) {
        return false
      }
      return true
    }
    function isCardNo (card) {
      var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/
      if (reg.test(card) === false) {
        return false
      }
      return true
    }
    function checkProvince (card, vcity) {
      var province = card.substr(0, 2)
      if (vcity[province] === undefined) {
        return false
      }
      return true
    }
    function checkBirthday (card) {
      var len = card.length
      var arrData, year, month, day, birthday, reEighteen
      if (len === 15) {
        reEighteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
        arrData = card.match(reEighteen)
        year = arrData[2]
        month = arrData[3]
        day = arrData[4]
        birthday = new Date('19' + year + '/' + month + '/' + day)
        return verifyBirthday('19' + year, month, day, birthday)
      }
      if (len === 18) {
        reEighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/
        arrData = card.match(reEighteen)
        year = arrData[2]
        month = arrData[3]
        day = arrData[4]
        birthday = new Date(year + '/' + month + '/' + day)
        return verifyBirthday(year, month, day, birthday)
      }
      return false
    }
    function verifyBirthday (year, month, day, birthday) {
      var now = new Date()
      var nowYear = now.getFullYear()
      if (birthday.getFullYear() === parseInt(year) && (birthday.getMonth() + 1) === parseInt(month) && birthday.getDate() === parseInt(day)) {
        var time = nowYear - year
        if (time >= 0 && time <= 100) {
          return true
        }
        return false
      }
      return false
    }
    function checkParity (card) {
      card = changeFivteenToEighteen(card)
      var len = card.length
      if (len === 18) {
        var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
        var cardTemp = 0
        var i
        var valnum
        for (i = 0; i < 17; i++) {
          cardTemp += card.substr(i, 1) * arrInt[i]
        }
        valnum = arrCh[cardTemp % 11]
        if (valnum === card.substr(17, 1).toLocaleUpperCase()) {
          return true
        }
        return false
      }
      return false
    }
    function changeFivteenToEighteen (card) {
      if (card.length === '15') {
        var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
        var cardTemp = 0
        var i
        card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6)
        for (i = 0; i < 17; i++) {
          cardTemp += card.substr(i, 1) * arrInt[i]
        }
        card += arrCh[cardTemp % 11]
        return card
      }
      return card
    }
  }
}
